import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Scenario } from 'src/app/core/models/scenario';
import { ConfirmationService, ConfirmEventType } from 'primeng/api';
import { MondelezService } from 'src/app/shared/services/mondelez.service';
import { ScenarioViewDialogComponent } from '../scenario-view-dialog/scenario-view-dialog.component';
import { ScenarioCreateDialogComponent } from '../scenario-create-dialog/scenario-create-dialog.component';
import { MondelezDataService } from 'src/app/shared/services/mondelez-data.service';
import { Subscription } from 'rxjs';
import { StorageHandler } from 'src/app/shared/handlers/storage-handler';
import { Router } from '@angular/router';

@Component({
  selector: 'app-scenario-list-dialog',
  templateUrl: './scenario-list-dialog.component.html',
  styleUrls: ['./scenario-list-dialog.component.scss'],
  providers: [ConfirmationService],
})
export class ScenarioListDialogComponent {
  public selectedScenario: Scenario;
  public scenarioMasterList: Scenario[] = [];

  private subs = new Subscription();

  constructor(
    private mondelezService: MondelezService,
    private mondelezDataService: MondelezDataService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ScenarioListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private confirmationService: ConfirmationService
  ) {}
  //data contains selected scenario and maxIteration Code
  ngOnInit(): void {
    this.selectedScenario = this.data.selectedScenario;
    this.subs.add(
      this.mondelezDataService.scenarioMaster.subscribe((masterData) => {
        this.scenarioMasterList = masterData;
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public OpenAddScenario(event: MouseEvent, id: number, iteration_code: number) {
    event.stopPropagation();
    if (iteration_code !== this.data.maxIterationCode) {
      console.log('Older Scenario: ' + iteration_code);
      return;
    }
    const addScenarioRef = this.dialog.open(ScenarioCreateDialogComponent, {
      width: '50vw',
      height: '53vh',
      disableClose: true,
      data: { id, iteration_code, scenarioMasterList: this.scenarioMasterList },
    });

    addScenarioRef.afterClosed().subscribe((result) => {
      if (result) {
        this.mondelezService.getScenarioData().subscribe();
      }
    });
  }

  public OpenViewScenario(event: MouseEvent, scenario: Scenario) {
    event.stopPropagation();
    const viewScenarioRef = this.dialog.open(ScenarioViewDialogComponent, {
      width: '50vw',
      height: '53vh',
      disableClose: true,
      data: { scenario },
    });

    viewScenarioRef.afterClosed().subscribe((result) => {
      if (result) {
        this.mondelezService.getScenarioData().subscribe();
      }
    });
  }

  public OnDeleteScenario(event: MouseEvent, scenario: Scenario) {
    event.stopPropagation();
    this.confirmationService.confirm({
      message: `Are you sure you want to delete the " ${scenario.scenario_name}? "`,
      accept: () => {
        this.mondelezService.deleteScenario({ scenario_id: scenario.scenario_id, iteration_id: scenario.iteration_code }).subscribe(
          (response) => {
            console.log('response :>> ', response);
            if (scenario.scenario_id === this.selectedScenario.scenario_id) {
              this.selectedScenario = this.data.selectedScenario;
            }
            this.mondelezService.getScenarioData().subscribe();
          },
          (err) => {
            console.log('response :>> ', err);
          }
        );
      },
      reject: (type: ConfirmEventType) => {
        console.log('rejected,type :>> ', type);
      },
    });
  }

  onClose(scenarioSelected: boolean): void {
    if (scenarioSelected) {
      this.dialogRef.close(this.selectedScenario);
    } else {
      this.dialogRef.close();
    }
  }

  onSelectScenario(scenario: Scenario) {
    StorageHandler.setLocalStorage('current_scenario', JSON.stringify(scenario));
    this.selectedScenario = scenario;
  }
}
